import $ from 'jquery';
import AOS from 'aos';
import Rellax from 'rellax';

import { Accordion } from './components/accordion';
import { AboutImageSlider } from './components/aboutImageSlider';
import { ImageGridSlider } from './components/imageGridSlider';
import { EventCalendar } from './components/eventCalendar';
import { ReadMore } from './components/readMore';
import { CalendarCategories } from './components/calendarCategories';
import { AddToCalendar } from './components/addToCalendar';
import { LoadMoreCardSet } from './components/loadMoreCardSet';
import { MobileNav } from './components/mobileNav';

const components = [
    AboutImageSlider,
    Accordion,
    AddToCalendar,
    CalendarCategories,
    EventCalendar,
    ImageGridSlider,
    ReadMore,
    LoadMoreCardSet,
    MobileNav,
];

document.addEventListener('DOMContentLoaded', () => {
    components.forEach(Component => Component.create());

    AOS.init({
        duration: 700,
        once: true,
    });

    if ($('.rellax').length) {
        // eslint-disable-next-line no-new
        new Rellax('.rellax', {
            speed: 1,
            center: true,
            round: true,
            vertical: true,
            horizontal: false,
        });
    }

    /* Open all truly external links in new tab */
    $('a[href^="http://"], a[href^="https://"]').on('click', function () {
        const currentHostname = window.location.hostname;
        const destHostname = this.hostname;
        if (currentHostname !== destHostname) {
            $(this).attr('target', '_blank');
        }
    });
});



// WEBPACK FOOTER //
// ./assets/js/main.js